import { useEffect, useState } from "react";
import * as monaco from "monaco-editor";
import axios from "axios";
import { codingLangVersion } from "./CodingLanguageVersion";
import { useLoader } from "../../context/loaderContext";

interface CodeOutputProps {
	editorRef: React.RefObject<monaco.editor.IStandaloneCodeEditor>;
	language: "javascript" | "java" | "python" | "csharp" | "ruby" | "php";
	runCode: boolean;
	setRunCode: React.Dispatch<React.SetStateAction<boolean>>;
}

const CodeOutput: React.FC<CodeOutputProps> = ({
	editorRef,
	language,
	runCode,
	setRunCode,
}) => {
	const { setLoading } = useLoader();
	const [output, setOutput] = useState(
		"Click 'Run Code' to see the output here."
	);
	const [isError, setIsError] = useState(false);

	const API = axios.create({
		baseURL: "https://emkc.org/api/v2/piston",
	});

	const getCodeOutput = async () => {
		const languageVersion = codingLangVersion[language];
		if (!languageVersion) {
			setOutput(`Unsupported language version for ${language}`);
			return;
		}

		try {
			setOutput("");
			setLoading(true);
			const response = await API.post("/execute", {
				language,
				version: languageVersion,
				files: [
					{
						content: editorRef.current?.getValue() || "",
					},
				],
			});

			setIsError(!!response.data.run.stderr);
			setOutput(response.data.run.stderr || response.data.run.output);
		} catch (error) {
			console.error("Error executing code:", error);
			setIsError(true);
			setOutput("An error occurred while executing the code.");
		} finally {
			setLoading(false);
		}
	};
	useEffect(() => {
		if (!runCode) return;
		getCodeOutput();
		setRunCode(false);
	}, [runCode]);

	return (
		<>
			<div className="w-[33%] 	">
				<div
					className={`rounded-lg h-[60vh] shadow-lg border overflow-auto  p-4 text-sm font-mono ${isError
						? "bg-red-50 border-red-500 text-red-600"
						: "bg-gray-50 border-gray-300 text-gray-800"
						}`}
				>
					<pre className="whitespace-pre-wrap h-full">{output}</pre>
				</div>
			</div>
		</>
	);
};

export default CodeOutput;
